import classNames from 'classnames';
import React, { InputHTMLAttributes } from 'react';
import { Styled } from 'types';
import uuidV4 from 'uuid/v4';

type CheckboxProps = Styled &
  InputHTMLAttributes<any> & {
    text: string;
  };

const Checkbox = ({
  text,
  id = uuidV4(),
  className,
  ...restProps
}: CheckboxProps) => (
  <div
    className={classNames('flex flex-shrink-0 items-center mb-4', className)}
  >
    <input
      type="checkbox"
      className="mr-4 flex-shrink-0"
      id={id}
      {...restProps}
    />
    <label htmlFor={id}>{text}</label>
  </div>
);

export default Checkbox;
